import { BrandMark } from '@/components/brand/BrandMark';

export function LoadingScreen() {
  return (
    <div className="relative flex h-full w-full items-center justify-center overflow-hidden bg-background">
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-1/2 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full bg-info-soft/30 blur-3xl"
      />
      <div className="relative flex flex-col items-center gap-4">
        <BrandMark className="h-10 w-10 animate-pulse" tone="humus" />
        <p className="text-sm text-muted-foreground">Loading…</p>
      </div>
    </div>
  );
}
